import React, { Component } from "react";
import PropTypes from "prop-types";
import Button from "./Button";
import styles from "./DropdownButton.module.css";

export default class DropdownButton extends Component {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.renderOption = this.renderOption.bind(this);
    this.state = {
      open: false,
    };
  }

  onClick() {
    this.setState({
      open: !this.state.open,
    });
  }

  renderOption(option, index) {
    const onClick = (e) => {
      if (option.data) {
        option.onClick(option.data);
      } else {
        option.onClick(e);
      }
    };

    if (option.type === "divider") {
      return <li key={index} className={styles.divider} />;
    }
    return (
      <li key={index} onClick={onClick}>
        {option.label}
      </li>
    );
  }

  render() {
    const { children, options } = this.props;

    return (
      <Button {...this.props} onClick={this.onClick}>
        {children || "▼"}
        <div
          className={styles.close + (this.state.open ? " " + styles.open : "")}
        />
        <ul
          className={styles.menu + (this.state.open ? " " + styles.open : "")}
        >
          {options.map(this.renderOption)}
        </ul>
      </Button>
    );
  }
}

DropdownButton.propTypes = {
  children: PropTypes.node,
  options: PropTypes.array.isRequired,
};
